import(/* webpackMode: "eager", webpackExports: ["GoogleTagManagerScript","GoogleTagManagerNoScript"] */ "/app/src/app/components/GoogleTagManager.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/app/DefaultLayout.jsx");
;
import(/* webpackMode: "eager" */ "/app/src/app/globals.css");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/app/src/redux/store/providers.jsx");
